import { render, staticRenderFns } from "./VProjectHeroBlock.vue?vue&type=template&id=6710af86&scoped=true&"
import script from "./VProjectHeroBlock.vue?vue&type=script&lang=js&"
export * from "./VProjectHeroBlock.vue?vue&type=script&lang=js&"
import style0 from "./VProjectHeroBlock.vue?vue&type=style&index=0&id=6710af86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6710af86",
  null
  
)

export default component.exports